import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Icon, Header } from "semantic-ui-react";
import { toast } from "react-toastify";

interface IProps {
  setFiles: (files: object[]) => void;
}

const dropzoneStyles = {
  border: "dashed 3px",
  borderColor: "#eee",
  borderRadius: "5px",
  paddingTop: "30px",
  textAlign: "center" as "center",
  height: "200px",
};
const dropzoneActive = {
  borderColor: "green",
};

const PhotoWidgetDropzone: React.FC<IProps> = ({ setFiles }) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      let name: string = acceptedFiles[0].name;
      if (
        name.includes(".png") ||
        name.includes(".jpg") ||
        name.includes(".jpeg") ||
        name.includes(".svg")
      ) {
        setFiles(
          acceptedFiles.map((file: MediaSource) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            })
          )
        );
      } else toast.error("Archivo con extencion invalida");
    },
    [setFiles]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div
      {...getRootProps()}
      style={
        isDragActive ? { ...dropzoneStyles, ...dropzoneActive } : dropzoneStyles
      }
    >
      <input {...getInputProps()} />
      <Icon name="upload" size="huge" />
      <Header content="Arrastra la imagen aqui!" />
    </div>
  );
};

export default PhotoWidgetDropzone;
